export const SUCCESS_SET = 'SUCCESS_SET';
export const SUCCESS_CLEAR = 'SUCCESS_CLEAR';
export const ERROR_SET = 'ERROR_SET';
export const ERROR_CLEAR = 'ERROR_CLEAR';
